import { __BrandFilterType, __BrandSearchParamsType } from '../brandDetail.type';
import { LanguageEnum } from '@/types';

export const __BrandServicesCheckFilterChange = (
    filters: __BrandFilterType,
    initialFilter: __BrandSearchParamsType,
) => {
    return (
        filters.page === initialFilter.page &&
        filters.order === initialFilter.order &&
        filters.search === initialFilter.search &&
        filters.category === initialFilter.category &&
        filters.starGTE === initialFilter.starGTE &&
        filters.starLTR === initialFilter.starLTR
    );
};

export const __BrandServicesFetchParams = (e: __BrandFilterType, language: LanguageEnum, brand: string) => {
    const params: { [key: string]: number | string[] | string | boolean } = {
        lang: language,
        page_size: 5,
        brand__slug__in: brand,
        brand__is_active: true,
        is_active: true,
    };
    if (e.page) params.page = e.page;
    if (e.category) params.category_and_descendants = e.category;
    if (e.starGTE) params.star_gte = e.starGTE;
    if (e.starLTR) params.star_lte = e.starLTR;
    if (e.search) params.title__icontains = e.search;
    if (e.order) params.order = e.order;
    else params.order = 'most_priority';
    // if (e.serviceType) params.service_type = params.serviceType;
    return params;
};
